export default "__VITE_ASSET__BMK5BSZ8__"